import { fetchDataAsGeoJSON, fetchAllDataAsGeoJSON } from "../util";
import { propertyFilter, boundaryFilter } from "../projectscope";
export class RoutesProvider {
    constructor(apiHost, authObject, projectScope, cacheSize = 50000) {
        this._apiHost = new URL(apiHost);
        this._authObject = authObject;
        this._projectScope = projectScope;
    }
    allRoutes(collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        try {
            const _propertyFilter = propertyFilter("routes", { projectScope: this._projectScope });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/routes/${collection}/query?limit=2000`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`&${_propertyFilter}`);
            }
            fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "POST", (geojson) => {
                onSuccess(geojson);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess({
                    features: [],
                    type: "FeatureCollection",
                });
                return;
            }
        }
    }
    allRouteLines(loa, collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        try {
            const _propertyFilter = propertyFilter("routeLines", {
                properties: [{ key: "loa", operator: "eq", value: loa.toString() }],
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/routeLines/${collection}/query?limit=2000`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`&${_propertyFilter}`);
            }
            fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "POST", (geojson) => {
                onSuccess(geojson);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess({
                    features: [],
                    type: "FeatureCollection",
                });
                return;
            }
        }
    }
    allRouteHexes(loa, collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        try {
            const _propertyFilter = propertyFilter("routeHexes", {
                properties: [{ key: "loa", operator: "eq", value: loa.toString() }],
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/routeHexes/${collection}/query?limit=1000`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`&${_propertyFilter}`);
            }
            fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "POST", (geojson) => {
                onSuccess(geojson);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess({
                    features: [],
                    type: "FeatureCollection",
                });
                return;
            }
        }
    }
    set authObject(authObject) {
        this._authObject = authObject;
    }
}
//# sourceMappingURL=routesprovider.js.map